module.exports = __webpack_public_path__ + "img/Jump Casting77.3caeb692.jpg";